import React, { useContext } from 'react';
import { Col, Row, Container } from 'react-bootstrap';
import { useAccordionButton } from 'react-bootstrap/AccordionButton';
import AccordionContext from 'react-bootstrap/AccordionContext';
import "./AccordionToggle.css"





export default function AccordionToggle({ children, eventKey }: { children: any, eventKey: any }) {
	const { activeEventKey } = useContext(AccordionContext);
	const decoratedOnClick = useAccordionButton(eventKey, () =>
		console.log('Changing accordion'),
	);

	const down = "data:image/svg+xml,%3Csvg fill='%23000000' version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 492 492' xml:space='preserve'%3E%3Cg%3E%3Cg%3E%3Cpath d='M442.668,268.536l-16.116-16.12c-5.06-5.068-11.824-7.872-19.024-7.872c-7.208,0-14.584,2.804-19.644,7.872 L283.688,355.992V26.924C283.688,12.084,272.856,0,258.02,0h-22.804c-14.832,0-28.404,12.084-28.404,26.924v330.24 L102.824,252.416c-5.068-5.068-11.444-7.872-18.652-7.872c-7.2,0-13.776,2.804-18.84,7.872l-16.028,16.12 c-10.488,10.492-10.444,27.56,0.044,38.052l177.576,177.556c5.056,5.056,11.84,7.856,19.1,7.856h0.076 c7.204,0,13.972-2.8,19.028-7.856l177.54-177.552C453.164,296.104,453.164,279.028,442.668,268.536z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E";
	const up = "data:image/svg+xml,%3Csvg fill='%23000000' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 492 492' xml:space='preserve'%3E%3Cg%3E%3Cg%3E%3Cpath d='M442.627,185.388L265.083,7.844C260.019,2.78,253.263,0,245.915,0c-7.204,0-13.956,2.78-19.02,7.844L49.347,185.388 c-10.488,10.492-10.488,27.568,0,38.052l16.12,16.128c5.064,5.06,11.82,7.844,19.028,7.844c7.204,0,14.192-2.784,19.252-7.844 l103.808-103.584v329.084c0,14.832,11.616,26.932,26.448,26.932h22.8c14.832,0,27.624-12.1,27.624-26.932V134.816l104.396,104.752 c5.06,5.06,11.636,7.844,18.844,7.844s13.864-2.784,18.932-7.844l16.072-16.128C453.163,212.952,453.123,195.88,442.627,185.388z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E";

	const isCurrentEventKey = activeEventKey === eventKey;

	const arrow = isCurrentEventKey ? up : down;

	return (
		<button
			type="button"
			onClick={decoratedOnClick}
			className="accordion-button"
		>
			<Container>
				<Row style={{ "margin": "0px" }}>
					<Col style={{ "padding": "0px" }}>
						{children}
					</Col>
					<Col className="card-header-right">
						<img style={{ height: "20px" }} src={arrow} />
					</Col>
				</Row>
			</Container>
		</button>
	);
}
